import { Component } from '@angular/core';

@Component({
  selector: 'app-e404',
  templateUrl: './e404.component.html',
})
export class E404Component {}
